import { Validators } from '@angular/forms';

/** */
export function segmentGroup (fb: any, { context }: { context?: string, count?: number }):any {
    switch (context) {
        case 'hotel':
            return fb.array([ hotel(fb) ]);
        case 'air':
            return fb.array([ air(fb) ]);
        default:
            return fb.array([ air(fb) ]);
    }
}

export function segmentGroupInArray (fb: any):any {
    return fb.group({
        begin: [''],
        from: [''],
        to: [''],
        fromAirportOnly: [''],
        toAirportOnly: [''],
    });
}

function hotel (fb: any):any {
    return fb.group({
        begin: ['', Validators.required],
        end: ['', Validators.required],
        duration: fb.group({
            night: ['', Validators.required]
        }),
        property: fb.group({
            host: [[], Validators.required],
            text: [''],
            locationName: [''],
            city: [''],
            keyword: [[]],
            geoposition: fb.group({
                latitude: [''],
                longitude: [''],
                radius: fb.group({
                    unit: [''],
                    max: ['']
                })
            }),
            rating: fb.group({
                standardisationBody: fb.group({
                    min: [''],
                    max: [5]
                }),
                traveller: fb.group({
                    min: [''],
                    max: [5]
                }),
                brand: fb.group({
                    min: [''],
                    max: [5]
                }),
            })
        })
    });
}

function air (fb: any):any {
    return fb.group({
        begin: ['', Validators.required],
        from: ['', Validators.required],
        to: ['', Validators.required],
        fromAirportOnly: [''],
        toAirportOnly: [''],
    });
}
